/*@flow*/

// PLEASE NOTE:
//
// This file contains only a subset of utility functions. They are
// extracted into their own file for testing purposes. When we need to
// change the functionality of a utility function we need to mock its
// module, and this cannot happen if the module also contains methods
// under test.
//
//
import filter from 'ramda/src/filter';
import compose from 'ramda/src/compose';
import omit from 'ramda/src/omit';
import keys from 'ramda/src/keys';
import findScrollContainer from 'lib/findScrollContainer';

export const sample = (arr: number[]): number =>
  arr[Math.floor(Math.random() * arr.length)];

export const scrollToElement = (anchor: ?HTMLElement) => {
  if (anchor) {
    const drawer = findScrollContainer(anchor);
    if (drawer === anchor) {
      $(drawer).scrollTop(0);
      $(document).scrollTop(0);
    } else {
      const containerOffset = $('.AnalyticsView').get(0).offsetTop;
      $(drawer).scrollTop(containerOffset + anchor.offsetTop - 20);
    }
  }
};

export const goTop = (e: { currentTarget: HTMLElement }) => {
  const container = findScrollContainer(e.currentTarget);
  if (container instanceof HTMLElement) {
    scrollToElement(container);
  } else {
    $(document).scrollTop(0);
  }
};

export const getNumericKeys: any = compose(
  keys,
  omit(['type'])
);
const filterNonZero = (data: Object[]) =>
  filter(column => data.some(v => v[column] > 0));
export const getNonZeroKeys = (data: Object[]): any =>
  compose(
    filterNonZero(data),
    getNumericKeys
  );
